import * as XLSX from 'xlsx';

function pct(n, total) {
  if (!total) return '0%';
  return `${((n / total) * 100).toFixed(1)}%`;
}

function summarySheet(audit, sourceName) {
  const rows = [
    ['Fitxer', sourceName || ''],
    ['Total registres', audit.totalRecords],
    ['Total camps', audit.totalFields],
    [],
    ['Tipus', 'Nombre de camps'],
    ...Object.entries(audit.typeBreakdown).map(([type, count]) => [type, count]),
  ];
  return XLSX.utils.aoa_to_sheet(rows);
}

function groupsSheet(audit) {
  const rows = [['Grup', 'Camp']];
  for (const { group, fields } of audit.groups) {
    for (const field of fields) {
      rows.push([group, field]);
    }
  }
  return XLSX.utils.aoa_to_sheet(rows);
}

// Etiqueta del domini per a l'informe (3 estats de l'auditoria).
const DOMAIN_LABELS = { closed: 'Tancat', open: 'Obert', undetermined: 'Indeterminat', empty: '—' };

function fieldsSheet(audit) {
  return XLSX.utils.aoa_to_sheet(auditFieldRows(audit));
}

// Files del descriptiu per camp (capçalera + una fila per columna). També el fa servir
// l'informe del procés (core/export/processReport.js) per al fitxer inicial i el final.
export function auditFieldRows(audit) {
  const rows = [
    ['Camp', 'Tipus', 'Total', 'Informats', 'Nuls', '% Nuls', 'Únics', 'Domini', 'Mostra (valor:freq)'],
  ];
  for (const c of audit.columns) {
    const sample = c.sample
      .slice(0, 20)
      .map((s) => `${s.value}:${s.count}`)
      .join(' | ');
    rows.push([
      c.name,
      c.detectedType,
      c.totalRecords,
      c.informed,
      c.nulls,
      pct(c.nulls, c.totalRecords),
      c.uniqueCount,
      DOMAIN_LABELS[c.domainClass] || (c.closedDomain ? 'Tancat' : 'Obert'),
      sample,
    ]);
  }
  return rows;
}

export function buildAuditWorkbook(audit, sourceName) {
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, summarySheet(audit, sourceName), 'Resum');
  XLSX.utils.book_append_sheet(wb, groupsSheet(audit), 'Agrupació');
  XLSX.utils.book_append_sheet(wb, fieldsSheet(audit), 'Descriptiu');
  return wb;
}

export function writeAuditWorkbook(audit, sourceName) {
  const wb = buildAuditWorkbook(audit, sourceName);
  return XLSX.write(wb, { type: 'array', bookType: 'xlsx' });
}

export function downloadAuditReport(audit, sourceName) {
  const wb = buildAuditWorkbook(audit, sourceName);
  const filename = `${(sourceName || 'auditoria').replace(/\.[^.]+$/, '')}_audit.xlsx`;
  XLSX.writeFile(wb, filename);
}
